module.exports = __webpack_public_path__ + "static/media/oauth_api.ac98ed23.md";